var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('main-section', {
    staticClass: "main-section--sm pb-0"
  }, [_c('square-title', [_vm._v("인증마크")]), _c('marks-list')], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }